import React, { Component } from 'react';
import PropTypes from 'prop-types';

import typeCheck from 'common/util/typeCheck';

import SrHouseholdNotesModalV2 from 'client/components/SrHouseholdNotesModalV2';
import SrFrontConversationModal from 'client/components/SrFrontConversationModal';
import SrHouseholdKanbanBoardCardV2 from 'client/components/SrHouseholdKanbanBoardCardV2/SrHouseholdKanbanBoardCardV2';

import branch from 'client/core/branch';

import {
  dataTable,
  actionDataTableLoadItems,
} from 'client/helpers/dataTables';

const COLUMN_REQUESTED = 'requested';
const COLUMN_TOURING = 'touring';

export function getDataTableHouseholdKanbanBoardTourSwimlanesSettingsFromProps({
  dataTableSource,
  moveInDateRanges,
  listingManagementCompany,
  listingServices,
  leasingManagerUserId,
}) {
  typeCheck('dataTableSource::NonEmptyString', dataTableSource);
  typeCheck('accountManagerUserId::Maybe Array', leasingManagerUserId);

  const viewId = [
    `${dataTableSource}:`,
    `startDate_${moveInDateRanges.join('-')}`,
    `listingManagementCompany-${listingManagementCompany}`,
    `listingServices_${(listingServices || []).join('-')}`,
    `leasingManagerUserId-${leasingManagerUserId}`,
  ].join('-');

  return {
    dataSource: dataTableSource,
    viewId: viewId,
    customParams: {
      householdKanbanTouring: {
        moveInDateRanges,
        listingManagementCompany,
        listingServices,
        leasingManagerUserId,
      },
    },
    filter: {},
    count: 10000,
  };
}

const getColumns = (items) => {
  const columns = {
    [COLUMN_REQUESTED]: [],
    [COLUMN_TOURING]: [],
  };

  for (const item of items) {
    if (item.listings.every((listing) => listing._type === 'requested')) {
      columns[COLUMN_REQUESTED].push(item);
    }
    else {
      columns[COLUMN_TOURING].push(item);
    }
  }

  return columns;
};

@dataTable(getDataTableHouseholdKanbanBoardTourSwimlanesSettingsFromProps)
@branch({
  currentUser: ['currentUser'],
})
class SrHouseholdKanbanBoardSwimlane extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    dataTableSource: PropTypes.string.isRequired,
    dataTableApiState: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      userIdToNotes: null,
      userIdToFrontConversation: null,
    };
  }

  componentDidMount() {
    this._loadItems();
  }

  componentDidUpdate() {
    this._loadItems();
  }

  _loadItems = () => {
    const { dispatch, dataTableIsFullyLoaded } = this.props;
    if (!dataTableIsFullyLoaded) {
      dispatch(
        actionDataTableLoadItems,
        getDataTableHouseholdKanbanBoardTourSwimlanesSettingsFromProps(this.props)
      );
    }
  }

  _onOpenFrontConversationModal = (userId) => {
    this.setState({
      userIdToFrontConversation: userId,
    });
  }

  _onCloseFrontConversationModal = () => {
    this.setState({
      userIdToFrontConversation: null,
    });
  }

  _onOpenHouseholdNotesModal = (userId) => {
    this.setState({
      userIdToNotes: userId,
    });
  }

  _onCloseHouseholdNotesModal = () => {
    this.setState({
      userIdToNotes: null,
    });
  }

  _onHouseholdNotesUpdated = () => {
    const { dispatch, dataTableSource } = this.props;
    const { userIdToNotes } = this.state;

    const { customParams } = getDataTableHouseholdKanbanBoardTourSwimlanesSettingsFromProps(this.props);

    dispatch(actionDataTableLoadItems, {
      dataSource: dataTableSource,
      viewId: dataTableSource,
      count: 1,
      customParams,
      filter: {
        'householdKanbanTours.id': userIdToNotes,
      },
    });
  }

  render() {
    const {
      items,
      dispatch,
      currentUser,
      dataTableApiState,
    } = this.props;
    const {
      userIdToNotes,
      userIdToFrontConversation,
    } = this.state;

    const columns = getColumns(items);

    return (
      <>
        {Object.keys(columns).map((columnName) => (
          <div key={columnName} className='householdKanbanBoardColumn'>
            <div className='columnName'>
              {`${columnName}${dataTableApiState.inProgress && columns[columnName].length === 0
                ? ''
                : ` (${columns[columnName].length})`}`}
            </div>
            <div className='columnCardContainer'>
              {columns[columnName].map((item) => {
                return (
                  <SrHouseholdKanbanBoardCardV2
                    key={item.id}
                    id={item.id}
                    name={item.name}
                    phone={item.phone}
                    email={item.email}
                    note={item.lastNote}
                    frontConversation={item.frontConversation}
                    frontLastMessageReceivedDate={item.frontLastMessageReceivedDate}
                    listings={item.listings}
                    dispatch={dispatch}
                    onClickNote={this._onOpenHouseholdNotesModal}
                    onClickFrontConversation={this._onOpenFrontConversationModal}
                  />
                );
              })}
              {dataTableApiState.inProgress &&
                <div className='loading-ellipses' />
              }
            </div>
          </div>
        ))}
        {userIdToFrontConversation && (
          <SrFrontConversationModal
            frontConversation={items.find((user) => user.id === userIdToFrontConversation).frontConversation}
            user={items.find((user) => user.id === userIdToFrontConversation)}
            dispatch={dispatch}
            onClose={this._onCloseFrontConversationModal}
          />
        )}

        {userIdToNotes && (
          <SrHouseholdNotesModalV2
            householdId={items.find((user) => user.id === userIdToNotes).householdId}
            dispatch={dispatch}
            currentUser={currentUser}
            onClose={this._onCloseHouseholdNotesModal}
            onUpdate={this._onHouseholdNotesUpdated}
          />
        )}
      </>
    );
  }
}

SrHouseholdKanbanBoardSwimlane.displayName = 'SrHouseholdKanbanBoardSwimlane';

export default SrHouseholdKanbanBoardSwimlane;
